import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useUserRole } from '../../lib/queries/useUserRole';

/**
 * Route-level guard for parent-portal surfaces. Mirrors the
 * `AcademyOnlyRoute` pattern from CalibrationContext.tsx.
 *
 *   - Loading: render nothing (avoid flashing a coach surface).
 *   - PARENT role: render children.
 *   - Any other role: redirect to `fallback` (default '/').
 *   - Anonymous: redirect to fallback (AuthGate will catch upstream
 *     for the bulk of routes; this guard sits inside AuthGate for
 *     authenticated parent surfaces).
 *
 * The consent flow Step 1–4 lives outside both AuthGate and this guard
 * because the parent doesn't have an account yet.
 */
export function ParentOnlyRoute({
  children,
  fallback = '/',
}: {
  children: ReactNode;
  fallback?: string;
}) {
  const { role, loading } = useUserRole();
  if (loading) return null;
  if (role !== 'PARENT') return <Navigate to={fallback} replace />;
  return <>{children}</>;
}
